module.exports = __webpack_public_path__ + "imgs/leafwell-logo-white.d1c1b787c2ab285eb46101051037429b.png";